import { Box, Button, Flex, Input, Radio, RadioGroup, Stack, Text } from '@chakra-ui/react';
import React, { useState } from 'react';
interface Props {
	jobSelect: string;
	setJobSelect: (jobSelect: string) => void;
}
const JobPreferrence = ({ jobSelect, setJobSelect }: Props) => {
	const handleChange = (value: string) => {
		setJobSelect(value);
	};

	return (
		<Flex alignItems={'flex-end'} justifyContent={'center'}>
			<Flex w="100%" mb={'6'} flexDirection={'column'}>
				<RadioGroup defaultValue="2" value={jobSelect} onChange={handleChange}>
					<Stack spacing={3} direction="column">
						<Box
							cursor="pointer"
							border={'1.4px solid'}
							padding={'12px'}
							borderColor={jobSelect === 'full-time-job' ? '#4358F6' : 'gray.200'}
							borderRadius={'10px'}
							textStyle={'h6'}
							onClick={() => setJobSelect('full-time-job')}
						>
							<Flex alignItems={'center'} gap={'1'} p={'8px'} color={'gray.900'} w={'full'} h={'40px'}>
								{jobSelect === 'full-time-job' ? <SelectedRadioIcon /> : <UnselectedRadioIcon />}
								<span className="custom-radio-label">Full - Time Job</span>
							</Flex>
						</Box>
						<Box
							cursor="pointer"
							border={'1.4px solid'}
							padding={'12px'}
							borderColor={jobSelect === 'internship' ? '#4358F6' : 'gray.200'}
							mt={'0'}
							borderRadius={'10px'}
							textStyle={'h6'}
							onClick={() => setJobSelect('internship')}
						>
							<Flex alignItems={'center'} gap={'1'} p={'8px'} color={'gray.900'} w={'full'} h={'40px'}>
								{jobSelect === 'internship' ? <SelectedRadioIcon /> : <UnselectedRadioIcon />}
								<span className="custom-radio-label">Internship</span>
							</Flex>
						</Box>
					</Stack>
				</RadioGroup>
			</Flex>
		</Flex>
	);
};

const UnselectedRadioIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
			<circle cx="12" cy="12" r="7.5" stroke="#848081" />
		</svg>
	);
};
const SelectedRadioIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
			<circle cx="12" cy="12" r="7.5" stroke="#4358F6" />
			<circle cx="12" cy="12" r="4" fill="#4358F6" />
		</svg>
	);
};

export default JobPreferrence;
